import { lazy } from 'react';

export const LazyAccountSettingsPage = lazy(
  () =>
    import(
      /* webpackChunkName: "hellospa--page--account-settings-page" */ './account-settings-page'
    ),
);
